import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'finx-switch',
  templateUrl: './finx-switch.component.html',
  styleUrls: ['./finx-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FinxSwitchComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinxSwitchComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);

  @Input() checkedValue: boolean;
  @Output() checkedValueChange = new EventEmitter<boolean>();
  @Input() isSmallSwitchButton = false;
  @Input() formControlName: string;
  @Input() formGroup: FormGroup;
  @Input() toggleActiveBgColour = 'var(--color-primary)';
  @Input() toggleInactiveBgColour = 'var(--color-on-primary-muted)';
  private _isChecked = false;
  @Input()
  set isChecked(value: boolean) {
    this._isChecked = value;
    this.checkedValue = value;
  }
  public readonly switchControl = new FormControl();
  ngOnInit() {
    this.switchControl.valueChanges.subscribe((inputString) => {
      this.onModelChange(inputString);
      this.onModelTouched();
      this.cd.detectChanges();
    });
    if (this.formGroup && this.formControlName) {
      const formControl = this.formGroup.get(this.formControlName);
      if (formControl) {
        this.checkedValue = formControl.value;
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelChange: Function = () => {};
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelTouched: Function = () => {};

  writeValue(value: boolean): void {
    value = value ?? false;
    this.switchControl.setValue(value);
    this.cd.markForCheck();
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClick(event: any) {
    this.checkedValue = event.target.checked;
    this.onModelChange(this.checkedValue);
    this.checkedValueChange.emit(this.checkedValue);
  }
}
